import React, { useState } from 'react'
import { useEffect } from 'react'
import { useTranslations } from '../contexts/translationContext'
import { useNotifications } from '../contexts/notificationContext'
import { StringWithFormat } from '../types/Result'

export interface IProps {
    token?: string
    context?: string
    defaultValue?: string | StringWithFormat
    children?: string | StringWithFormat
}

export const Translate: React.FC<IProps> = ({
    token,
    context,
    defaultValue,
    children,
}): JSX.Element => {

    const [translatedText, setTranslatedText] = useState<string>('')
    const { translate } = useTranslations()
    const { handleException } = useNotifications();

    useEffect(() => {
        let defaultText: string | StringWithFormat = ''
        if (token) defaultText = token
        if (children) defaultText = children
        if (defaultValue) defaultText = defaultValue

        let translationKey = ''
        if (token) translationKey = token
        else if (typeof defaultText === 'string') translationKey = defaultText
        else translationKey = defaultText.format

        console.log('Key:', translationKey)

        translate(translationKey, context, defaultText)
            .then((translated: string) => setTranslatedText(translated))
            .catch(e => handleException(e));

    }, [translate, token, context, defaultValue, children])

    return <React.Fragment>{translatedText}</React.Fragment>
}
export default Translate
